import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { colors, breakpoints } from 'globalStyles'
import { selectIsUserVerified } from 'store/shipping/shippingSelectors'
import { useSelector } from 'react-redux'
import Verification from 'components/Verification'
import PackagePreferencesModal from 'components/PackagePreferencesModal'

const ViewPreferencesLink = styled.a.attrs({
  id: 'login-link',
  rel: 'noreferrer',
  href: '#',
})`
  color: ${colors.primary_blue};
  &:hover {
    color: ${colors.text_link_hover};
  }
`

const StyledDiv = styled.div`
  text-align: center;
  @media screen and ${breakpoints.desktop} {
    text-align: left;
  }
`

const ViewPackagePreferences = () => {
  const { t } = useTranslation()
  const [showModal, setShowModal] = useState(false)
  const [showVerificationPopUp, setShowVerificationPopUp] = useState(false)
  const isVerifiedUser = useSelector(selectIsUserVerified)
  const [pendingAction, setPendingAction] = useState(() =>
    sessionStorage.getItem('preferenceAction')
  )

  const clearSessionStorage = () => {
    setPendingAction(null)
    sessionStorage.removeItem('preferenceAction')
  }

  useEffect(() => {
    if (!pendingAction) return
    if (isVerifiedUser) {
      setShowModal(true)
    } else {
      setShowVerificationPopUp(true)
    }
  }, [isVerifiedUser, pendingAction])

  const onClickViewPreferences = (popupType) => {
    if (isVerifiedUser) {
      setShowModal(true)
    } else {
      // Store popupType directly in sessionStorage
      sessionStorage.setItem('preferenceAction', popupType)
      setShowVerificationPopUp(true)
    }
  }

  return (
    <StyledDiv>
      <ViewPreferencesLink onClick={() => onClickViewPreferences('viewPref')}>
        {t('package_preferences.view_preferences')}
      </ViewPreferencesLink>
      <Verification
        show={showVerificationPopUp}
        onHide={(closeValue) => {
          setShowVerificationPopUp(closeValue)
          // If user cancels verification, clear pending action
          if (closeValue === false) {
            clearSessionStorage()
          }
        }}
      />
      <PackagePreferencesModal
        show={showModal}
        onClose={() => {
          setShowModal(false)
          clearSessionStorage()
        }}
      />
    </StyledDiv>
  )
}

export default ViewPackagePreferences
